export default __webpack_public_path__ + "images/fa9fb7d36b8efe5592e3ab344bba2e4e.png";